export const leicaWorkHoursPerDay = ({leica}) => leica.adminDashboardSettings.leicaWorkHoursPerDay;
export const resources = ({leica}) => leica.resources;
export const systemsWithChecklistData = ({leica}) => leica.systemsWithChecklistData;
export const employees = ({leica}) => leica.employees;